import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "./presentations/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DecadenceNormalWinPresentation} from "./presentations/DecadenceNormalWinPresentation";
import {DecadenceBigWinFlow} from "./presentations/DecadenceBigWinFlow";
import {DecadenceFSOutroPresentation} from "./presentations/DecadenceFSOutroPresentation";
import {DecadenceSymbolCopyPresentation} from "./presentations/DecadenceSymbolCopyPresentation";
import {DecadenceRetriggerPresentation, DecadenceSFSPresentation} from "./presentations/DecadenceSFSPresentation";
import {
    DecadenceCopyFromLockedReelPresentation,
    DecadenceCopyToLockedReelPresentation
} from "./presentations/DecadenceLockedReelPresentation";
import {Decadence} from "../Decadence";
import {DecadenceWinCapPresentation} from "./presentations/DecadenceWinCapPresentation";

export class DecadenceWinFlow implements FlowStatePresentation {
    private presentations:SimplePresentation[];

    constructor() {
        this.presentations = [
            new DecadenceCopyFromLockedReelPresentation(),
            new DecadenceSymbolCopyPresentation(),
            new DecadenceNormalWinPresentation(),
            new DecadenceBigWinFlow(),
            new DecadenceCopyToLockedReelPresentation(),
            new DecadenceWinCapPresentation(),

            new DecadenceSFSPresentation(),
            new DecadenceRetriggerPresentation(),

            new DecadenceFSOutroPresentation(),
        ];
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => {flowStateController.finish()}, (callback?:Function) => {flowStateController.setSkipCallback(callback)}, "WinRunner");
    }

}